import { subscribeByID } from '@adornis/baseql/operations/mongo.js';
import { confirmDialog, guardDialog, showDialog } from '@adornis/dialog/dialog-functions.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { DialogHeader } from '@adornis/components/client/DialogHeader.js';
import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { Person } from '../../users/entities/person.js';
import { SepaAPI } from '../api/SepaAPI.js';

const ShowMissingIBANUsersDialogContent = stateful((props: { userIDs: string[]; resolve: () => void }) => {
  const { value: usersWithoutIban } = useQuery(
    () =>
      subscribeByID(
        Person,
        props.userIDs,
      )({
        _id: 1,
        email: 1,
        debitorennummer: 1,
        profilDaten: {
          stammdaten: {
            vorname: 1,
            nachname: 1,
          },
        },
      }),
    [],
  );

  return html`
    <div class="dialog-container">
      ${DialogHeader({ title: `${usersWithoutIban?.length ?? 0} Benutzer ohne IBAN`, close: props.resolve, closeLabel: 'Dialog schließen' })}

      <p>
        Für diese Personen konnte keine/keine gültige IBAN auf der Person direkt oder ihren Sorgeberechtigten gefunden
        werden.
      </p>
      <div class="martinus-selection-backdrop gap-2 grid grid-cols-[max-content_1fr]">
        ${repeat(
          usersWithoutIban ?? [],
          user => user._id,
          user => html`
            <a href="/personen/${user._id}" target="_blank" class="martinus-selection-card">
              <span class="text-sm opacity-70 badge badge-neutral">${user.debitorennummer ?? user.email}</span>
              <span> ${user.profilDaten?.stammdaten?.vorname} ${user.profilDaten?.stammdaten?.nachname} </span>
            </a>
          `,
        )}
      </div>
    </div>
  `;
});

export async function acceptAllSepaMandatesForGroup(groupID: string) {
  if (
    !(await confirmDialog(
      'Mit dieser Funktion werden alle SEPA-Mandate für die Abrechnungsposition dieser Gruppe angenommen. Sind Sie sich sicher, dass Sie die ausdrückliche Zustimmung aller benötigten Personen besitzen?',
      {
        highlightDecline: true,
        declineText: 'Abbrechen',
        acceptText: 'Ich besitze die ausdrückliche Zustimmung',
      },
    ))
  )
    return;

  const result = await guardDialog<string[]>(
    async () => {
      return SepaAPI.acceptAllMandatesForGroup(groupID)();
    },
    {
      successText: 'SEPA-Mandate erfolgreich akzeptiert',
    },
  );

  if (Array.isArray(result) && result.length) {
    await showDialog<void>({
      content: resolve => ShowMissingIBANUsersDialogContent({ userIDs: result, resolve }),
    });
  }
}
